import Tabs from 'bee-tabs'

export default Tabs
